import { Injectable, Inject } from '@angular/core';
// import * as AWS from 'aws-sdk';
import { Lambda } from 'aws-sdk';
import { LambdaClientConfig, WebAPICallResult, WebAPICallOptions } from './models';
import { Observable } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { lambdaErrorFromResult, platformErrorFromResult } from './errors';
import { Helper } from './helper';
import { LAMBDA_CLIENT_CONFIG } from './ts-sdit-data.module';

@Injectable({
  providedIn: 'root'
})
export class LambdaClientService {
  private lambda: Lambda;
  private jwt: string;

  constructor(
    @Inject(LAMBDA_CLIENT_CONFIG) private config: LambdaClientConfig,
    private logger: NGXLogger,
    private helper: Helper) {
    this.lambda = new Lambda({
      region: this.config.region,
      apiVersion: this.config.apiVersion || '2015-03-31',
      credentials: this.config.credentials,
    });
  }
  setJwt(jwt: string) {
    this.jwt = jwt;
  }
  invoke(
    functionName: string,
    options: WebAPICallOptions,
    invocationRequest?: Lambda.Types.InvocationRequest): Observable<WebAPICallResult> {
    const name = this.helper.genLambdaFunctionName(functionName);
    const requestPayload = {
      jwt: this.jwt,
      ...options,
    };
    const pullParams: Lambda.Types.InvocationRequest = {
      FunctionName: name,
      InvocationType: 'RequestResponse',
      Payload: JSON.stringify(requestPayload),
      ...invocationRequest
    };
    this.logger.debug('lambda invoke request', pullParams);
    return new Observable<WebAPICallResult>(subscriber => {
      this.lambda.invoke(pullParams, (err, data) => {
        if (err) {
          this.logger.error(`invoke lambda failed`, err.message);
          const webApiLambdaError = lambdaErrorFromResult(err);
          subscriber.error(webApiLambdaError);
          return;
        } else if (data.FunctionError) {
          this.logger.error(`invoke lambda function failed`, JSON.parse(data.Payload as string));
          const platformError = platformErrorFromResult(data.Payload as string, data.FunctionError);
          subscriber.error(platformError);
          return;
        }
        const parsedPayload = JSON.parse(data.Payload as string);
        this.logger.debug(`lambda res payload`, parsedPayload);
        const result: WebAPICallResult = {
          ...parsedPayload,
        };
        subscriber.next(result);
        subscriber.complete();
      });
    });
  }
}
